import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  List,
  ListItem,
  ListItemText,
  Typography,
  Box,
  CircularProgress,
  Container,
} from "@mui/material";

import SearchField from "../Components/SearchField";
import useAccountSettings from "../ManageAccount/useAccountSettings";
import useProjects from "./useProjects";
import ProjectItem from "./ProjectItem";

export default function Projects({ size = "large" }) {
  const { t } = useTranslation();
  // local state
  const [search, setSearch] = useState(""); // search query
  const [list, setList] = useState([]); // filtered projects based on search query
  const isLoading = false;

  // server state
  const { accountSettings } = useAccountSettings();
  const { projects, isLoading: isProjectsLoading } = useProjects();
  const myProject = {
    id: 0,
    firstName: accountSettings.firstName,
    lastName: accountSettings.lastName,
    code: accountSettings.code,
    boardId: 0,
    path: "/timeline",
  };

  // search in list
  useEffect(() => {
    const handleList = () => {
      setList(
        projects.filter(
          (project) =>
            project.firstName
              .toLocaleLowerCase()
              .includes(search.toLocaleLowerCase()) ||
            project.lastName
              .toLocaleLowerCase()
              .includes(search.toLocaleLowerCase())
        )
      );
    };
    if (search === "") {
      handleList();
    } else {
      const timeOutId = setTimeout(() => {
        handleList();
      }, 400);
      return () => {
        clearTimeout(timeOutId);
      };
    }
  }, [search, projects, isProjectsLoading]);

  return (
    <Container maxWidth={size === "small" ? "xl" : "sm"}>
      <Box
        display="flex"
        justifyContent={"space-between"}
        sx={{ gap: 1 }}
        alignItems="center"
        paddingTop={2}
      >
        <Typography variant="h6">{t("projects.choose")}</Typography>
      </Box>
      <Box padding={1} />
      <SearchField setUserText={setSearch} placeholder={t("projects.search")} />
      <Box padding={1} />
      {isLoading ? ( // loading
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height={250}
        >
          <CircularProgress />
        </Box>
      ) : (
        <List>
          {list.length > 0 ? (
            <Box>
              <ProjectItem project={myProject} />
              {list.map((project) => (
                <ProjectItem key={project.id} project={project} />
              ))}
              <Box padding={1} />
            </Box>
          ) : (
            // no results found
            <ListItem>
              <ListItemText primary={t("projects.noSearchResults")} />
            </ListItem>
          )}
        </List>
      )}
    </Container>
  );
}
